import { useQuery } from '@tanstack/react-query';
import { minutesToMilliseconds } from 'date-fns';
import { useMemo } from 'react';
export const useFeatures = (api) => {
    const featuresQueryKey = useMemo(() => ['featureFlags'], []);
    const featureFlags = useQuery({
        queryKey: featuresQueryKey,
        queryFn: async () => {
            const { data } = await api.featureFlags.get();
            return data;
        },
        staleTime: minutesToMilliseconds(120),
    });
    return { featureFlags };
};
